import type { SxProps, Theme } from '@mui/material';

// ─── Visually hidden (screen-reader only) ─────────────────────────────────────

export const srOnlySx: SxProps<Theme> = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  whiteSpace: 'nowrap',
  border: 0
};

// ─── Dialog paper (white box) ─────────────────────────────────────────────────

export const dialogPaperSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: 629,
  m: { xs: 2, sm: 3 },
  minHeight: 200,
  borderRadius: '12px',
  boxShadow: '0px 10px 30px 0px rgba(0,0,0,0.10)',
  overflow: 'visible',
   py: { xs: '20px', sm: 4 },
  px: { xs: '20px', sm: 4 },
  gap: 4,
  '& :focus-visible': {
    outline: '2px solid black',
    outlineOffset: '5px'
  }
};

// ─── Header row ───────────────────────────────────────────────────────────────

export const dialogHeaderSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
 
  pb: '12px'
};

// ─── Title ────────────────────────────────────────────────────────────────────

export const dialogTitleSx: SxProps<Theme> = {
  fontFamily: 'AC Nord Text, sans-serif',
  fontSize: { xs: '18px', sm: '24px' },
  fontWeight: 700,
  lineHeight: '32px',
  letterSpacing: 0,
  color: 'var(--Sem-text-colour-text-primary, #000000)',
  mr: 2
};

// ─── Close icon button ────────────────────────────────────────────────────────

export const dialogCloseButtonSx: SxProps<Theme> = {
  p: '4px',
  mt: '2px',
  flexShrink: 0,
  color: 'var(--Sem-text-colour-text-primary, #000000)',
  borderRadius: '4px',
  '&:focus-visible': {
    outline: '1px solid black',
    outlineOffset: '2px'
  }
};

// ─── Content area ─────────────────────────────────────────────────────────────

export const dialogContentSx: SxProps<Theme> = {
  // px: { xs: '20px', sm: '32px' },
  // pb: { xs: '20px', sm: '20px' },
  overflowY: 'auto',
  maxHeight: '60vh',
  px: '4px'
};

// ─── Body text ────────────────────────────────────────────────────────────────

export const dialogBodySx: SxProps<Theme> = {
  fontFamily: 'AC Nord Text, sans-serif',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '22px',
  letterSpacing: 0,
  color: 'var(--Sem-text-colour-text-primary, #000000)',
  mb: 2
};

// ─── Radio button ─────────────────────────────────────────────────────────────

export const dialogRadioSx: SxProps<Theme> = {
  p: '6px 9px',
  color: '#1460AA',
  '&.Mui-checked': {
    color: '#002345'
  },
  '&.Mui-focusVisible': {
    outline: '1px solid black',
    outlineOffset: '2px',
    borderRadius: '50%'
  }
};

// ─── Radio form-control label ─────────────────────────────────────────────────

export const dialogRadioLabelSx: SxProps<Theme> = {
  '& .MuiFormControlLabel-label': {
    fontFamily: 'AC Nord Text, sans-serif',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: 0,
    color: 'var(--Sem-text-colour-text-primary, #000000)'
  }
};

// ─── Action row ───────────────────────────────────────────────────────────────

export const dialogActionsSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  // px: { xs: '20px', sm: '32px' },
  // pb: { xs: '20px', sm: '24px' },
  // pt: { xs: 0, sm: '4px' },
  flexDirection: { xs: 'column', sm: 'row' },
  gap: { xs: 1.5, sm: 0 },
  '& > button': {
    width: { xs: '100%', sm: 'auto' }
  }
};
